// import React from 'react';
// import {Link} from 'react-router';
// import {Menu} from 'antd';
// import {layout} from 'icsoc-antd-ex';

// const {BaseContent, BaseContentMain, BaseContentSider} = layout;

// const TaskManage = ({
//   children,
//   location: {pathname = '/taskManage/list'} = {},
// }) => {
//   const defaultSelectedKeys =
//     (pathname === '/taskManage' ? '/taskManage/list' : pathname) ||
//     '/taskManage/list';
//   const background =
//     pathname === '/taskManage/questionNaire' ? 'background' : '';

//   const baseContentSiderRender = (
//     <BaseContentSider
//       title="任务管理"
//       selectedKeys={[defaultSelectedKeys]}
//       mode="inline">
//       <Menu.Item key="/taskManage/list">
//         <Link to="/taskManage/list">任务列表</Link>
//       </Menu.Item>
//       <Menu.Item key="/taskManage/detail">
//         <Link to="/taskManage/detail">任务详情</Link>
//       </Menu.Item>
//       <Menu.Item key="/taskManage/statistic">
//         <Link to="/taskManage/statistic">任务统计</Link>
//       </Menu.Item>
//       <Menu.Item key="/taskManage/questionNaire">
//         <Link to="/taskManage/questionNaire">问卷统计</Link>
//       </Menu.Item>
//     </BaseContentSider>
//   );

//   return (
//     <BaseContent>
//       {baseContentSiderRender}
//       <BaseContentMain className={background}>{children}</BaseContentMain>
//     </BaseContent>
//   );
// };

import React from 'react';

class TaskManage extends React.PureComponent {
  componentDidMount() {}

  render() {
    const {children} = this.props;
    return <div className="container sysmanage-container">{children}</div>;
  }
}

export default TaskManage;
